import { combineReducers } from '@reduxjs/toolkit'
import contracts from './contracts.store'
import signedTerms from './signed-terms.store'

export const rootReducer = combineReducers({
  contracts,
  signedTerms,
})
